import { render, staticRenderFns } from "./PcProductList.vue?vue&type=template&id=3fb4a3e6&scoped=true&"
import script from "./PcProductList.vue?vue&type=script&lang=js&"
export * from "./PcProductList.vue?vue&type=script&lang=js&"
import style0 from "./PcProductList.vue?vue&type=style&index=0&id=3fb4a3e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4a3e6",
  null
  
)

export default component.exports